'use client';

import React from 'react';

const STARTERS = [
  'I need to vent',
  "I\'m overthinking",
  'Distract me',
  'Help me think this through',
  'Just stay with me',
];

interface Props {
  onSelect: (text: string) => void;
  visible: boolean;
}

export default function ConversationStarters({ onSelect, visible }: Props) {
  if (!visible) return null;

  return (
    <div className="px-4 pb-2 fade-in">
      <div className="max-w-2xl mx-auto">
        <p className="text-[11px] text-muted-foreground/70 font-medium mb-2 px-0.5">Start with…</p>
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
          {STARTERS.map((s) => (
            <button
              key={s}
              onClick={() => onSelect(s)}
              className="flex-shrink-0 px-3 py-1.5 rounded-full border border-border/80 bg-card text-foreground/80 text-[12px] font-medium transition-all duration-200 hover:border-primary/50 hover:text-primary hover:bg-primary/5 active:scale-95 whitespace-nowrap"
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
